import { createFileRoute } from '@tanstack/react-router';

// By path: the feature's index would bring its other pages into this chunk.
import { ExecutionImagesPage } from '@/features/execution-images/components/ExecutionImagesPage';
import { imagesSearchSchema } from '@/features/settings';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/settings/images',
)({
  // The palette's verb, and the old `/execution-images?create` address (spec 224).
  validateSearch: imagesSearchSchema,
  component: ImagesRoute,
});

export function ImagesRoute() {
  const { workspaceId } = Route.useParams();
  const { create } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ExecutionImagesPage
      workspaceId={workspaceId}
      createRequested={create === true}
      onCreateDismissed={() => {
        // Spent once the sheet is open, so a reload does not open it again.
        void navigate({ search: {}, replace: true });
      }}
    />
  );
}
